<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Pembayaran Hutang - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Pembayaran Hutang - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Pembelian / Pembayaran Hutang / Edit</span
        >
        <span v-else class="font-small"
          >/ Pembelian / Pembayaran Hutang / Tambah</span
        >
      </div>
    </div>
    <form-pembayaran :id="id" />
  </div>
</template>

<script>
import FormPembayaran from '@/components/pembelian/FormPembayaran'

export default {
  components: {
    FormPembayaran,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
